<template>
	<div class="moonSampleInfoClass">
		<el-page-header @back="goBack" class="backClass" content="详情页面"> </el-page-header>
		<div class="titleNameClass">{{ sampleData.code }}</div>
		<div class="contentDivClass">
			<div class="spanInforDivClass">
				<div class="titleDivClass">
					<span class="titleSpanNameClass">探测任务信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">探测任务</span>
						<span class="valueClass">{{ sampleData.task }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">地点</span>
						<span class="valueClass">{{ sampleData.place }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">经度</span>
						<span class="valueClass">{{ sampleData.longitude }}W</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">纬度</span>
						<span class="valueClass">{{ sampleData.latitude }}S</span>
					</div>
				</div>

				<div class="titleDivClass">
					<span class="titleSpanNameClass">样品基本信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">样品编号</span>
						<span class="valueClass">{{ sampleData.code }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">样品特征</span>
						<span class="valueClass" v-html="sampleData.sampleType"></span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">样品数量</span>
						<span class="valueClass">{{ sampleData.num == null ? '暂无数据' : sampleData.num }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">重量</span>
						<span class="valueClass">{{ sampleData.availableWeight == null ? '暂无数据' : sampleData.availableWeight }}mg</span>
					</div>
					<!-- <div class="dataInforDivClass">
						<span class="nameClass">样品粒度</span>
						<span class="valueClass">{{ sampleData.lidu }}</span>
					</div> -->
				</div>

				<div class="titleDivClass">
					<span class="titleSpanNameClass">样品分类信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">一级分类</span>
						<span class="valueClass">{{ sampleData.sampleCategory1 }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">二级分类</span>
						<span class="valueClass">{{ sampleData.sampleCategory2 }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">三级分类</span>
						<span class="valueClass">{{ sampleData.sampleCategory3 }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">四级分类</span>
						<span class="valueClass">{{ sampleData.sampleCategory4 == null ? '暂无数据' : sampleData.sampleCategory4 }}</span>
					</div>
				</div>

				<div class="titleDivClass">
					<span class="titleSpanNameClass">样品描述信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">颜色</span>
						<span class="valueClass">{{ sampleData.color == null ? '暂无数据' : sampleData.color }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">结构</span>
						<span class="valueClass">{{ sampleData.structure == null ? '暂无数据' : sampleData.structure }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">矿物组成</span>
						<span class="valueClass">{{ sampleData.mineralComposition == null ? '暂无数据' : sampleData.mineralComposition }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">样品说明</span>
						<span class="valueClass" v-html="sampleData.content"></span>
					</div>
				</div>
			</div>
			<div class="sampleBorrowingClass">
				<div class="titleDivClass">
					<span class="titleSpanNameClass">样品借用信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div>
					<el-table :data="sampleBorrwingTable" stripe :height="300" style="width: 100%">
						<el-table-column prop="companyName" label="使用单位"> </el-table-column>
						<el-table-column prop="usePerson" label="使用责任人"> </el-table-column>
						<el-table-column prop="borrowReviewTime" label="实际借用时间"> </el-table-column>
						<el-table-column prop="actualReturnTime" label="实际返还时间"> </el-table-column>
						<el-table-column prop="borrowWeight" label="发放质量(mg）"> </el-table-column>
						<el-table-column prop="useType" label="使用方式">
							<template #default="scope">
								<!--1:原样使用,2:消耗性使用,3:破坏性使用,4:展览,5:教育,6:科普,7:其他 -->
								<span v-if="scope.row.useType == 1">原样使用</span>
								<span v-else-if="scope.row.useType == 2">消耗性使用</span>
								<span v-else-if="scope.row.useType == 3">破坏性使用</span>
								<span v-else-if="scope.row.useType == 4">展览教育科普</span>
								<span v-else-if="scope.row.useType == 5">赠送</span>
								<!-- <span v-else-if="scope.row.useType == 6">科普</span> -->
								<span v-else>其他</span>
							</template>
						</el-table-column>
						<el-table-column prop="returnWeight" label="返还质量(mg)"> </el-table-column>
						<el-table-column prop="actualConsumption" label="实际消耗(mg)"> </el-table-column>
						<template v-slot:empty>
							<el-empty v-if="sampleBorrwingTable.length == 0" description="暂无数据"></el-empty>
						</template>
					</el-table>
				</div>

				<div class="titleDivClass">
					<span class="titleSpanNameClass">图片样本信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div>
					<div style="display: block; text-align: left; margin-bottom: 10px">总共 {{ sampleImageInfo.length }} 条记录</div>
					<div class="imgSampleClass">
						<el-carousel style="width: 100%" :active-item-index="activeIndex" @change="handleActiveIndexChange" :interval="4000" type="card" height="400px">
							<el-carousel-item v-for="(item, index) in sampleImageInfo" :key="index">
								<img :src="item.image" style="heigth: 300px; width: 400px" />
								<!-- <img src="./../../../assets/moonsamples/img1.png" /> -->
								<div class="infoDivClass" v-if="activeIndex == index">
									<p class="infoClass" v-html="item.remark2"></p>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeIndex: 0,
			sampleData: '',
			sampleImageInfo: [],
			sampleBorrwingTable: []
		}
	},
	methods: {
		handleActiveIndexChange(index) {
			this.activeIndex = index
			console.log('当前激活的幻灯片索引:', index)
			// 获取当前激活的幻灯片数据
			const currentItem = this.carouselItems[index]
			console.log('当前激活的幻灯片数据:', currentItem)
		},
		goBack() {
			this.$emit('goBackFunc', 1)
		},
		async initDataFunc(row) {
			console.log(row)
			this.sampleData = row
			// if(!cookie.get('userCreateBy')){
			// 	alert('请登录用户！')
			// 	return
			// }
			let imageArr = ''
			let remarkArr = ''
			if (row.images[0]) {
				imageArr = row.images[0].image.split(',')
				if (row.images[0].remark) {
					remarkArr = row.images[0].remark.split('||')
				}
			}
			this.sampleImageInfo = []
			if (imageArr && imageArr.length > 0) {
				imageArr.forEach((element, index) => {
					this.sampleImageInfo.push({ image: element, remark2: remarkArr[index] ? remarkArr[index] : '没有描述信息' })
				})
			}

			const params = {
				pageSize: 1000,
				pageNum: 1,
				parentCode: row.code
			}
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleBorrowingReturn, params)
			if (res && res.code == 200) {
				this.sampleBorrwingTable = res.rows
				// this.totalMoonSample = res.total
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.moonSampleInfoClass {
	width: 1200px;
	text-align: center;
	display: inline-block;
	.backClass {
		height: 40px;
		width: 100%;
		background: linear-gradient(90deg, rgba(251, 251, 251, 0.5) 0%, #f8f8f8 49%, rgba(245, 245, 245, 0.5) 100%);
		line-height: 40px;
	}
	.titleNameClass {
		height: 80px;
		font-family: MicrosoftYaHeiUISemibold;
		font-size: 28px;
		color: #000000;
		line-height: 80px;
		text-align: left;
		font-style: normal;
	}
	.contentDivClass {
		width: 1200px;
		// height: 1196px;
		background: #ffffff;
		border-radius: 4px;
		padding: 24px;
		border: 1px solid rgba(21, 65, 140, 0.2);
		.spanInforDivClass,
		.sampleBorrowingClass {
			display: flex;
			flex-direction: column;
			justify-content: left;
			.titleDivClass {
				display: flex;
				justify-content: left;
				align-items: center;
				height: 60px;
				.titleSpanNameClass {
					width: 108px;
					height: 19px;
					font-family: ReeJi-BigRuixain, ReeJi-BigRuixain;
					font-weight: normal;
					font-size: 18px;
					color: #15418c;
					line-height: 19px;
					text-align: left;
					font-style: normal;
					font-weight: 600;
				}
				.lineRightClass {
					width: 88%;
					// border-image: linear-gradient(270deg, rgba(21, 65, 140, 0.1), rgba(21, 65, 140, 0.3)) 1 1;
					border-style: dashed;
					border-width: 1px;
					border-color: #abc0e3;
				}
			}
			.spanInforClass {
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 1100px;
				height: 60px;
				.dataInforDivClass {
					display: flex;
					justify-content: left;
					align-items: center;
					width: 300px;
					.nameClass {
						width: 120px;
						height: 40px;
						display: flex;
						align-items: center;
						justify-content: center;
						background: rgba(21, 65, 140, 0.08);
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
					.valueClass {
						// height: 21px;
						width: 150px;
						font-family: MicrosoftYaHeiUISemibold;
						font-size: 16px;
						color: #15418c;
						line-height: 21px;
						text-align: left;
						font-style: normal;
						word-break: break-all;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: normal;
					}
				}
			}
			.imgSampleClass:hover .infoDivClass {
				display: inline;
			}
			.imgSampleClass {
				display: flex;
				justify-content: center;
				align-items: center;
				.imgInforClass {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: space-between;
					width: 90%;
					flex-direction: row;
					span {
						width: auto;
						// width: 500px;
						height: 32px;
						background: #15418c;
						border-radius: 16px;
						opacity: 0.5;
						color: #fff;

						padding-right: 15px;
						padding-left: 15px;
						margin-top: 24px;
						line-height: 32px;
						font-size: 14px;
					}
				}

				.infoDivClass {
					width: 100%;
					position: absolute;
					height: 90%;
					background: rgba(0, 0, 0, 0.4);
					right: 0px;
					// padding: 20px 25px;
					display: none;
					.infoClass {
						font-family: '微软雅黑';
						margin: 0px 0 0px 0;
						line-height: 1.5;
						color: #fff;
						text-align: left;
						padding: 10px;
						font-size: 18px;
					}
				}
			}
		}
	}
}
</style>

<style>
.el-carousel__item h3 {
	color: #475669;
	font-size: 14px;
	opacity: 0.75;
	line-height: 200px;
	margin: 0;
}

.el-carousel__item:nth-child(2n) {
	background-color: unset;
	width: auto;
}

.el-carousel__item:nth-child(2n + 1) {
	background-color: unset;
	width: auto;
}
</style>